import { Github } from "@styled-icons/boxicons-logos/Github"
import { LinkedinWithCircle } from "@styled-icons/entypo-social/LinkedinWithCircle"
import { InstagramWithCircle } from "@styled-icons/entypo-social/InstagramWithCircle"
import { MediumWithCircle } from "@styled-icons/entypo-social/MediumWithCircle"
const Icons = {
  Github,
  LinkedinWithCircle,
  InstagramWithCircle,
  MediumWithCircle,
}

export default Icons
